import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

export default function LoggedOut() {
  const navigate = useNavigate();
  // const { instance } = useMsal();

  useEffect(() => {
    // Clear any residual storage
    localStorage.clear();
    sessionStorage.clear();

    // // Clear all MSAL accounts to prevent auto-login
    // const accounts = instance.getAllAccounts();
    // accounts.forEach((account) => {
    //   instance.setActiveAccount(null);
    // });

    // instance.clearCache().catch(console.error);
  }, [navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        textAlign: "center",
        p: 3,
      }}
    >
      <Typography variant="h4" gutterBottom>
        You've been successfully logged out
      </Typography>
    </Box>
  );
}
